import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import DataParser from "../../../utlits/Dataparser";
import DesignationService from "../../../Services/DesignationService";
import { Helmet } from "react-helmet";
import StatusBadge from "../../Reuseable/StatusBadge";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import secureLocalStorage from "react-secure-storage";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";
message.config({ zIndex: 1000000001 });

const Designations = () => {
  const navigate = useNavigate();
  const [Designations, setDesignations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [designationName, setDesignationName] = useState("");
  const [designationNameEdit, setDesignationNameEdit] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [editID, setEditID] = useState("");
  const [error, setError] = useState("");
  const companyId = DataParser.CompanyId();

  useEffect(() => {
    if (pageSize > 15) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getDesignations = () => {
    setIsLoading(true);
    const companyId = DataParser.CompanyId();

    DesignationService.getCompanyDesignation(companyId, { params: { showAll: 1 } })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        const dataset = res.data?.designations || [];
        setDesignations(dataset);
      })
      .catch((err) => {
        console.error("Error fetching designations:", err);
        message.error("Failed to load designations. Please try again!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getDesignations();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();
    const handleDesignationUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getDesignations();
      }
    };
    SocketService.on("designation_update", handleDesignationUpdate);
    return () => {
      SocketService.off("designation_update", handleDesignationUpdate);
    };
  }, []);

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteDsgnModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    const newData = Designations.filter((el) => el.id !== id);
    setDesignations(newData);
    document.getElementById("closeDsgnDeleteModal").click();
    const companyId = DataParser.CompanyId();
    try {
      const res = await DesignationService.deleteDesignation(id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Designation deleted successfully!");
      }
      getDesignations();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete designation. Please try again!");
    }
    setItemToDelete(null);
  };

  const handleOpenUpdate = (e, item) => {
    e.preventDefault();
    setDesignationNameEdit(item.name);
    setEditID(item.id);
  };

  const handelSubmit = (e) => {
    e.preventDefault();

    if (!designationName || designationName.trim() === "") {
      setError("Designation name is required!");
      return;
    }

    const AddData = {
      name: designationName.trim(),
      company_id: companyId,
    };

    DesignationService.createDesignation(AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("Designation created successfully!");
          const link = document.getElementById("DesignationModalCreate");
          if (link) link.click();
          getDesignations();
          setDesignationName("");
        } else {
          message.warning("Failed to create designation. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error creating designation:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while creating the designation."
        );
      });
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (!designationNameEdit || designationNameEdit.trim() === "") {
      setError("Designation name is required!");
      return;
    }

    const AddData = {
      name: designationNameEdit.trim(),
      company_id: companyId,
    };

    DesignationService.editDesignation(editID, AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("Designation updated successfully!");
          const link = document.getElementById("DesignationModalEdit");
          if (link) link.click();
          getDesignations();
        } else {
          message.warning("Failed to update designation. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error updating designation:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while updating the designation."
        );
      });
  };

  const clearCreateState = () => {
    setDesignationName("");
    setError("");
  };

  const clearEditState = () => {
    setDesignationNameEdit("");
    setEditID("");
    setError("");
  };

  const PaginatedData = paginate(Designations, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Designations - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Designations</li>
                    </ol>
                    {userPermissions.indexOf("designation-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createDesignationModal"
                      >
                        Create Designation
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Designation
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Designation Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : (
                            <>
                              {PaginatedData && PaginatedData.length > 0 ? (
                                PaginatedData.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>
                                      {userPermissions.indexOf("designation-edit") !== -1 ? (
                                        <StatusBadge
                                          item={item}
                                          api={DesignationService.updateDesignation}
                                        />
                                      ) : (
                                        <>
                                          {item.status === 1 ? (
                                            <span className="badge bg-success text-white">Active</span>
                                          ) : (
                                            <span className="badge bg-danger text-white">Deactive</span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td className="tableset">
                                      {userPermissions.indexOf("departments-delete") !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handelDelete(e, item)}
                                        >
                                          <Tooltip title="Delete Designation">
                                            <i className="uil-trash iconscolor" />
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <span
                                          className="uil-trash iconscolor text-muted"
                                          style={{ cursor: "not-allowed", opacity: 0.5 }}
                                          title="You don't have permission to delete"
                                        />
                                      )}
                                      {userPermissions.indexOf("designation-edit") !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handleOpenUpdate(e, item)}
                                          data-bs-toggle="modal"
                                          data-bs-target="#editDesignationModal"
                                        >
                                          <Tooltip title="Edit Designation">
                                            <i className="uil-pen iconscolor" />
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <span
                                          className="uil-pen iconscolor text-muted"
                                          style={{ cursor: "not-allowed", opacity: 0.5 }}
                                          title="You don't have permission to edit"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="12" className="text-center">
                                    Add your first designation by clicking the 'Create Designation' button.
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>

                      {Designations.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={Designations.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteDsgnModal" data-bs-toggle="modal" data-bs-target="#deleteDesignationModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteDesignationModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Designation</h5>
                <button type="button" className="btn-close" id="closeDsgnDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this designation?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create modal */}
        <div
          id="createDesignationModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Designation</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="DesignationModalCreate"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="Name"
                      placeholder=" "
                      value={designationName}
                      onChange={(e) => {
                        setDesignationName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="Name">Designation Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Designation
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit modal */}
        <div
          id="editDesignationModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelEditSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Designation</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="DesignationModalEdit"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="NameEdit"
                      placeholder=" "
                      value={designationNameEdit}
                      onChange={(e) => {
                        setDesignationNameEdit(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="NameEdit">Designation Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelEditSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Designations;
